import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrupoUsuarioList() {
  // Use toast
  const toast = useToast()

  const refGrupoListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: '#' },
    { key: 'grupousuario', sortable: true, label: 'Nome' },
    { key: 'ativo', sortable: true, label: 'Status' },
    { key: 'data_inclusao', sortable: true, label: 'Data Criação' },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(10)
  const totalGrupoUsuario = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 15, 20, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refGrupoListTable.value ? refGrupoListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalGrupoUsuario.value,
    }
  })

  const refetchData = async () => {
    await store.dispatch('appGruposPermissions/FIND_GROUPS')
    refGrupoListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const getStatus = status => {
    if (['1', 1, 'active', 'ativo', true, 'true'].indexOf(status) !== -1) {
      return 1
    }
    if (['0', 0, 'inactive', 'inativo', false, 'false'].indexOf(status) !== -1) {
      return 0
    }
    return null
  }

  const fetchGrupos = (ctx, callback) => {
    store
      .dispatch('app-adm-grupousuario/fetchUGrupos', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        ativo: getStatus(statusFilter.value),
      })
      .then(response => {
        const { grupos, total } = response.data

        callback(grupos)
        totalGrupoUsuario.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'Admin B2B') return 'primary'
    if (role === 'Cliente B2B') return 'warning'
    if (role === 'Admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'Cliente B2B') return 'UserIcon'
    if (role === 'Admin B2B') return 'SettingsIcon'
    if (role === 'Admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 1) return 'success'
    if (status === 0) return 'secondary'
    return 'primary'
  }

  return {
    fetchGrupos,
    tableColumns,
    perPage,
    currentPage,
    totalGrupoUsuario,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refGrupoListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    statusFilter,
  }
}
